"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _ListItem = _interopRequireWildcard(require("../../../ListItem"));
var _Collapsible = _interopRequireDefault(require("../../../Collapsible"));
var _Icon = require("../../../Icon");
var Styled = _interopRequireWildcard(require("./style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var SelectListItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.type,
    type = _a === void 0 ? _ListItem.ListItemTypes.Normal : _a,
    parentId = props.parentId,
    children = props.children,
    onSelect = props.onSelect,
    filteredProps = __rest(props, ["type", "parentId", "children", "onSelect"]);
  var isNested = children !== undefined ? true : false;
  var _b = (0, _react.useState)(false),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var handleToggleNested = (0, _react.useCallback)(function () {
    setIsExpanded(function (current) {
      return !current;
    });
  }, []);
  var handleOnNestedListClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var handleOnSelect = (0, _react.useCallback)(function (value) {
    if (typeof onSelect === 'function') {
      onSelect(value, parentId);
    }
  }, [onSelect, parentId]);
  var actionIcon = isNested ? isExpanded ? _Icon.Icons.ChevronUp : _Icon.Icons.ChevronDown : undefined;
  return (0, _jsxRuntime.jsx)(_ListItem.default, __assign({}, filteredProps, {
    ref: ref,
    type: type,
    actionIcon: actionIcon,
    onSelect: handleOnSelect,
    onActionClick: handleToggleNested
  }, {
    children: isNested ? (0, _jsxRuntime.jsx)(_Collapsible.default, __assign({
      open: isExpanded
    }, {
      children: (0, _jsxRuntime.jsx)(Styled.List, __assign({
        tabIndex: -1,
        allowKeyboardNavigation: false,
        type: type,
        onClick: handleOnNestedListClick
      }, {
        children: children
      }))
    })) : null
  }));
});
SelectListItem.displayName = 'SelectListItem';
var _default = SelectListItem;
exports.default = _default;